////////LIBRARY/////////
import update from 'immutability-helper'
import { cloneDeep, isEqual } from 'lodash'
///////COMPONENTS///////
import extendUpdate from '../../helpers/extendUpdate'
import ActionsTypes from '../../constants/ActionsTypes'

extendUpdate(update)

const myAccount = {
	[ActionsTypes.GET_ACCOUNT]: (state) =>
		update(state, {
			myAccount: {
				isLoading: {
					$set: true,
				},
			},
		}),
	[ActionsTypes.GET_ACCOUNT_SUCCESS]: (state, payload) => {
		return update(state, {
			myAccount: {
				isLoading: {
					$set: false,
				},
				items: {
					$set: { ...payload.user },
				},
			},
		})
	},
	[ActionsTypes.GET_ACCOUNT_FAILURE]: (state, payload) =>
		update(state, {
			myAccount: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		}),
	[ActionsTypes.UPDATE_MY_ACCOUNT]: (state) =>
		update(state, {
			myAccount: {
				isLoading: {
					$set: true,
				},
			},
		}),
	[ActionsTypes.UPDATE_MY_ACCOUNT_SUCCESS]: (state, payload) => {
		const firstName = payload.user.firstName
		const lastName = payload.user.lastName
		const prevFirstName = state.user.identity.firstName
		const prevLastName = state.user.identity.lastName
		const userCp = cloneDeep(state.user.identity)

		if (!isEqual(firstName, prevFirstName) || !isEqual(lastName, prevLastName)) {
			userCp.firstName = firstName
			userCp.lastName = lastName
		}

		return update(state, {
			myAccount: {
				isLoading: {
					$set: false,
				},
				items: {
					$set: { ...payload.user },
				},
			},
			user: {
				identity: {
					$set: userCp,
				},
			},
		})
	},
	[ActionsTypes.UPDATE_MY_ACCOUNT_FAILURE]: (state, payload) =>
		update(state, {
			myAccount: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		}),
}

export default myAccount
